import { Http, Response } from '@angular/http';
import { SearchModel } from '../models/searchModel';
import { ApiError } from '../models/api-error';

export class BaseService {
    constructor(protected path: string, protected http: Http) { }

    list(searchModel: SearchModel = {}) {
        if (searchModel.filterId === null) searchModel.filterId = '';
        return this.http
            .get('/' + this.path + '/list', {
                params: { filterId: searchModel.filterId, query: searchModel.query }
            })
            .map(this.extractData);
    }

    find(id) {
        return this.http.get('/' + this.path + '/find/' + id).map(this.extractData);
    }

    delete(id) {
        return this.http
            .post('/' + this.path + '/delete/' + id, null)
            .map(this.extractData);
    }

    create(entity) {
        let url = '/' + this.path + '/create';
        return this.http.post(url, entity).map(this.extractData);
    }

    update(entity) {
        let url = '/' + this.path + '/update';
        return this.http.post(url, entity).map(this.extractData);
    }

    extractData(res: Response) {
        let body = res.json();
        if (!body.status) {
            if (body.errorMessage) {
                throw new ApiError({ message: body.errorMessage });
            } else if (body.validations && body.validations.length > 0) {
                var validationMessages = '';
                for (let i = 0; i < body.validations.length; i++) {
                    const validationMessage = body.validations[i];
                    validationMessages += validationMessage + '\n';
                }
                throw new ApiError({ message: validationMessages });
            }
        }
        return body || {};
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/services/base.service.ts